const STORE_SERVER_URL = process.env.REACT_APP_SERVICE_API_URL || "http://localhost:8085";

async function StoreApiFetch(path, options = {}) {
    const {
        method = "GET",
        body = null,
        headers = {},
    } = options;
    
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    
    const requestHeaders = {
        "Content-Type": "application/json",
        ...headers,
    };

    const response = await fetch(`${STORE_SERVER_URL}/service${normalizedPath}`, {
        method,
        headers: requestHeaders,
        ...(body ? { body: JSON.stringify(body) } : {}),
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch (error) {
        console.error("Error parsing JSON response:", error);
    }

    if (!response.ok) {
        const requestError = new Error(
            payload.error || payload.message || "An error occurred while fetching data."
        );
        requestError.status = response.status;
        requestError.details = payload.details;
        throw requestError;
    }

    return payload;
} 


export async function getAppointmentByHashID(hashedAppointmentID, token = "") {
    const params = new URLSearchParams({ hashed_appointment_id: hashedAppointmentID });
    if (token) {
        params.set("token", token);
    }
    return StoreApiFetch(`/payments/appointments/fetch?${params.toString()}`);
}

export async function confirmAppointmentDepositByToken(token, hashedAppointmentID) {
    const params = new URLSearchParams({ token });
    const path = `/payments/appointments/confirm-deposit?${params.toString()}`;

    return StoreApiFetch(path, {
        method: "POST",
        body: {
            token,
            hashed_appointment_id: hashedAppointmentID,
        },
    });
}

export async function handlePaymentFailure(hashedAppointmentID, token = "") {
    const params = new URLSearchParams({ token });
    const path = `/payments/appointments/${encodeURIComponent(hashedAppointmentID)}/failure?${params.toString()}`;

    return StoreApiFetch(path, {
        method: "POST",
        body: {
            token,
            hashed_appointment_id: hashedAppointmentID,
        },
    });
}

export async function notifyCustomerOfPaymentFailure(customerID, token = "") {
    const params = new URLSearchParams({ token });
    const path = `/payments/customers/${encodeURIComponent(customerID)}/notify-failure?${params.toString()}`;

    return StoreApiFetch(path, {
        method: "POST",
        body: {
            token,
            customer_id: customerID,
        },
    });
}